module.exports = __webpack_public_path__ + "img/duels.5ca47425.png";